import { render, staticRenderFns } from "./ImageWithCardOverlay.vue?vue&type=template&id=130307e8&"
import script from "./ImageWithCardOverlay.vue?vue&type=script&lang=js&"
export * from "./ImageWithCardOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports